import { Fragment, useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import swal from "sweetalert";
import api from "../../../api";
import PageTitle from "../../layouts/PageTitle";
import FilePreview from "../Common/FilePreview";

const HandoverAdd = () => {
 const [searchParams] = useSearchParams();

const workOrderFromUrl = searchParams.get("workOrder") || "";
const projectFromUrl = searchParams.get("project") || "";
const navigate = useNavigate();
 const [workOrders, setWorkOrders] = useState([]);
 const [boqItems, setBoqItems] = useState([]);
 const [billings, setBillings] = useState([]);
 const [loading, setLoading] = useState(false);

 // MAIN FORM
 const [form, setForm] = useState({
 hoNumber: "",
 workOrder: "", // [OK] renamed
 boqSelected: [],
 handoverDocuments: [],
 checklist: [],
 clientSignature: null,
 billingLinked: "",
 status: "Pending",
 });
 

 // CHECKLIST TEMP
 const [checklistItem, setChecklistItem] = useState({
 item: "",
 status: "Pending",
 remarks: "",
 });

 // BOQ TEMP ITEM
 const [boqItemTemp, setBoqItemTemp] = useState({
 boqId: "",
 description: "",
 quantity: "",
 });

 const [handoverDocsPreview, setHandoverDocsPreview] = useState([]);
 const [clientSignPreview, setClientSignPreview] = useState(null);

 // ===============================
 // SUBMIT
 // ===============================
 const handleSubmit = async (e) => {
 e.preventDefault();

 

 if (!form.workOrder) {
 swal("Oops", "Please select a work order", "error");
 return;
 }

 setLoading(true);

 try {
 const payload = {
 workOrder: form.workOrder, // [OK] correct
 status: form.status,
 checklist: form.checklist,
 boqSelected: form.boqSelected,
 handoverDocuments: form.handoverDocuments,
 clientSignature: form.clientSignature,
 };

 if (form.billingLinked) {
 payload.billingLinked = form.billingLinked;
 }

 const res = await api.post("/handover", payload);

 if (res.data.success) {
 swal("Success", "Handover created successfully!", "success");
 navigate(
 workOrderFromUrl
 ? `/handover?${projectFromUrl ? `project=${projectFromUrl}&` : ""}workOrder=${workOrderFromUrl}`
 : "/handover"
);
 } else {
 swal("Error", res.data.message || "Failed to create handover", "error");
 }
 } catch (error) {
 swal("Error", error.response?.data?.message || error.message, "error");
 } finally {
 setLoading(false);
 }
 };

 const removeHandoverDoc = (index) => {
 setForm((prev) => ({
 ...prev,
 handoverDocuments: prev.handoverDocuments.filter((_, i) => i !== index),
 }));

 setHandoverDocsPreview((prev) => prev.filter((_, i) => i !== index));
 };

 const removeClientSign = () => {
 setForm((prev) => ({ ...prev, clientSignature: null }));
 setClientSignPreview(null);
 };

 // ===============================
 // FETCH DATA
 // ===============================

 // FETCH WORK ORDERS
 // useEffect(() => {
 // if (form.workOrder) fetchBOQ(form.workOrder);
 // }, [form.workOrder]);
 useEffect(() => {
 if (form.workOrder) {
 fetchBOQ(form.workOrder);
 fetchNextHoNumber(form.workOrder); // ADD THIS
 }
}, [form.workOrder]);
const fetchNextHoNumber = async (workOrderId) => {
    if (!workOrderId) return;
    try {
      const res = await api.get("/handover/next-number", {
        params: { workOrder: workOrderId },
      });

      if (res.data.success) {
        setForm((prev) => ({
          ...prev,
          hoNumber: res.data.hoNumber || res.data.nextNumber || "",
        }));
      }
    } catch (err) {
      console.log("Next HO number fetch failed", err);
    }
  };

 const fetchWorkOrders = async () => {
 try {
 const res = await api.get("/work-orders?limit=1000");
 if (res.data.success) setWorkOrders(res.data.data);
 } catch (err) {
 swal("Error", "Failed to load work orders", "error");
 }
 };
useEffect(() => {
    if (workOrderFromUrl && workOrders.length > 0) {
      setForm((prev) => ({
        ...prev,
        workOrder: workOrderFromUrl,
      }));
    }
  }, [workOrders, workOrderFromUrl]);
 // FETCH BILLINGS
 const fetchBillings = async () => {
 try {
 const res = await api.get("/billing");
 if (res.data.success) setBillings(res.data.data);
 } catch (err) {
 console.log(err);
 }
 };

 // FETCH BOQ WHEN PROJECT CHANGES
 // useEffect(() => {
 // if (form.project) fetchBOQ(form.project);
 // }, [form.project]);

 const fetchBOQ = async (workOrderId) => {
 try {
 const res = await api.get(`/work-orders/${workOrderId}/boq`);
 if (res.data.success) setBoqItems(res.data.data);
 else setBoqItems([]);
 } catch (error) {
 swal("Error", "Failed to load BOQ list", "error");
 setBoqItems([]);
 }
 };

 // HANDLE INPUT CHANGE
 const handleChange = (e) => {
 setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

 };

 // HANDLE CHECKLIST
 const handleChecklistChange = (e) => {
 setChecklistItem((prev) => ({ ...prev, [e.target.name]: e.target.value }));
 };

 const addChecklistItem = () => {
 if (!checklistItem.item.trim())
 return swal("Warning", "Checklist item required", "warning");

 setForm((prev) => ({
 ...prev,
 checklist: [...prev.checklist, checklistItem],
 }));

 setChecklistItem({ item: "", status: "Pending", remarks: "" });
 swal("Success", "Checklist added", "success");
 };

 const removeChecklistItem = (index) => {
 setForm((prev) => ({
 ...prev,
 checklist: prev.checklist.filter((_, i) => i !== index),
 }));
 swal("Removed", "Checklist removed", "success");
 };

 // ===========================
 // BOQ ADD / REMOVE
 // ===========================

 const handleBOQChange = (e) => {
 setBoqItemTemp((prev) => ({ ...prev, [e.target.name]: e.target.value }));
 };

 const addBOQItem = () => {
 if (!boqItemTemp.boqId)
 return swal("Warning", "Please select a BOQ item", "warning");

 if (!boqItemTemp.description.trim())
 return swal("Warning", "Please enter description", "warning");

 if (!boqItemTemp.quantity || boqItemTemp.quantity <= 0)
 return swal("Warning", "Enter valid quantity", "warning");

 // find selected BOQ
 const selected = boqItems.find((b) => b._id === boqItemTemp.boqId);

 if (selected && Number(boqItemTemp.quantity) > Number(selected.availableHandoverQuantity)) {
 swal({
 title: "Warning",
 text: `Quantity entered (${boqItemTemp.quantity}) exceeds remaining quantity (${selected.availableHandoverQuantity}). Do you want to proceed?`,
 icon: "warning",
 buttons: true,
 dangerMode: true,
 }).then((willAdd) => {
 if (willAdd) {
 performAddBOQItem(selected);
 }
 });
 return;
 }

 performAddBOQItem(selected);
 };

 const performAddBOQItem = (selected) => {
 setForm((prev) => ({
 ...prev,
 boqSelected: [
 ...prev.boqSelected,
 {
 ...boqItemTemp,
 boqItemId: boqItemTemp.boqId,
 // [OK] keep for UI
 boqName: `[WLI-${selected?.wlino || "-"}] ${selected?.itemName}`,
 // [OK] NEW: matches backend schema (itemName)
 itemName: `[WLI-${selected?.wlino || "-"}] ${selected?.itemName}`,
 unit: selected?.unit,
 },
 ],
 }));

 swal("Success", "BOQ item added", "success");
 setBoqItemTemp({ boqId: "", description: "", quantity: "" });
 };

 const removeBOQItem = (index) => {
 setForm((prev) => ({
 ...prev,
 boqSelected: prev.boqSelected.filter((_, i) => i !== index),
 }));

 swal("Removed", "BOQ item removed", "success");
 };

 // FILE TO BASE64
 const fileToBase64 = (file) =>
 new Promise((resolve) => {
 const reader = new FileReader();
 reader.onload = () => resolve(reader.result);
 reader.readAsDataURL(file);
 });

 // FILE HANDLERS
 const handleFile = async (e, field) => {
 if (field === "handoverDocuments") {
 const files = Array.from(e.target.files);

 const converted = await Promise.all(
 files.map(async (file) => ({
 fileName: file.name,
 fileUrl: await fileToBase64(file),
 documentType: file.name.split(".").pop().toUpperCase(),
 })),
 );

 setForm((prev) => ({
 ...prev,
 handoverDocuments: [...prev.handoverDocuments, ...converted],
 }));

 setHandoverDocsPreview((prev) => [
 ...prev,
 ...files.map((f) => ({ name: f.name, size: f.size })),
 ]);

 swal("Success", "Documents added", "success");
 } else {
 const file = e.target.files[0];
 if (!file) return;

 const base64 = await fileToBase64(file);

 setForm((prev) => ({
 ...prev,
 clientSignature: { fileName: file.name, fileUrl: base64 },
 }));

 setClientSignPreview(base64);
 swal("Success", "Client signature added", "success");
 }
 };
 useEffect(() => {
 fetchWorkOrders();
 fetchBillings();
}, []);

 // ===============================
 // PART 2 — UI (BOQ + CHECKLIST + FILES + SIGNATURE)
 // ===============================

 return (
 <Fragment>
 <PageTitle activeMenu="Add Handover" motherMenu="ITC" />

 <Row>
 <Col lg={12}>
 <Card>
 <Card.Header className="d-flex justify-content-between align-items-center">
 <Card.Title>Add Handover</Card.Title>
 <button
 type="button"
 className="btn btn-secondary"
 onClick={() =>
 navigate(
 workOrderFromUrl
 ? `/handover?${projectFromUrl ? `project=${projectFromUrl}&` : ""}workOrder=${workOrderFromUrl}`
 : "/handover"
 )
}
 >
 <i className="fas fa-arrow-left me-2"></i>
 Back
 </button>
 </Card.Header>

 <Card.Body>
 <form onSubmit={handleSubmit}>
 <Row>
 {/* HO NUMBER */}
 <Col md={6}>
 <div className="mb-3">
 <label className="form-label">HO Number *</label>
 <input
 type="text"
 className="form-control"
 value={form.hoNumber || "Will be generated automatically"}
 readOnly
/>
 </div>
 </Col>

 {/* PROJECT */}
 <Col md={6}>
 <div className="mb-3">
 <label className="form-label">Work Order *</label>

 <select
 name="workOrder"
 className="form-select"
 value={form.workOrder}
 onChange={handleChange}
 >
 <option value="">Select Work Order</option>

 {workOrders.map((wo) => (
 <option key={wo._id} value={wo._id}>
 {wo.woNo}{wo.label ? ` – ${wo.label}` : ""}
 </option>
 ))}
 </select>
 </div>
 </Col>
 </Row>

 {/* STATUS + BILLING */}
 <Row>
 <Col md={6}>
 <div className="mb-3">
 <label className="form-label">Status</label>
 <select
 name="status"
 className="form-select"
 value={form.status}
 onChange={handleChange}
 >
 <option value="Pending">Pending</option>
 </select>
 </div>
 </Col>

 <Col md={6}>
 <div className="mb-3">
 <label className="form-label">
 Billing Linked (Optional)
 </label>
 <select
 name="billingLinked"
 className="form-select"
 value={form.billingLinked}
 onChange={handleChange}
 >
 <option value="">Select Billing</option>
 {billings.map((b) => (
 <option key={b._id} value={b._id}>
 {b.billingNumber || b.invoiceNumber || b._id}
 </option>
 ))}
 </select>
 </div>
 </Col>
 </Row>

 {/* ============================ */}
 {/* BOQ SELECTION SECTION */}
 {/* ============================ */}
 <div className="mb-4">
 <label className="form-label fw-bold">BOQ Work Done</label>
 <Card className="border">
 <Card.Body>
 <Row className="g-2 mb-3">
 <Col md={3}>
 <select
 name="boqId"
 className="form-select"
 value={boqItemTemp.boqId}
 onChange={handleBOQChange}
 >
 <option value="">Select BOQ</option>
 {boqItems.map((item) => (
 <option key={item._id} value={item._id}>
 [WLI-{item.wlino || "-"}] {item.itemName} ({item.unit})
 </option>
 ))}
 </select>
 {boqItemTemp.boqId && (
 <div className="mt-1 small text-muted">
 {(() => {
 const selected = boqItems.find(
 (b) => b._id === boqItemTemp.boqId
 );
 return selected ? (
 <>
 <span className="me-2">
 Total: <strong>{selected.quantity}</strong>
 </span>
 <span>
 Used: <strong>{selected.handoverUsedQuantity || 0}</strong>
 </span>
 <div className="text-primary mt-1">
 Remaining: <strong>{selected.availableHandoverQuantity || 0}</strong>
 </div>
 </>
 ) : null;
 })()}
 </div>
 )}
 </Col>

 <Col md={5}>
 <input
 type="text"
 name="description"
 className="form-control"
 placeholder="Work Description"
 value={boqItemTemp.description}
 onChange={handleBOQChange}
 />
 </Col>

 <Col md={2}>
 <input
 type="number"
 name="quantity"
 className="form-control"
 placeholder="Qty"
 value={boqItemTemp.quantity}
 onChange={handleBOQChange}
 />
 </Col>

 <Col md={2}>
 <button
 type="button"
 className="btn btn-primary w-100"
 onClick={addBOQItem}
 >
 <i className="fas fa-plus me-1"></i> Add
 </button>
 </Col>
 </Row>

 {/* BOQ TABLE */}
 {form.boqSelected.length > 0 ? (
 <table className="table table-bordered table-sm">
 <thead className="table-light">
 <tr>
 <th>BOQ Item</th>
 <th>Description</th>
 <th>Qty</th>
 <th>Unit</th>
 <th>Action</th>
 </tr>
 </thead>
 <tbody>
 {form.boqSelected.map((item, i) => (
 <tr key={i}>
 <td>{item.boqName || item.itemName}</td>
 <td>{item.description}</td>
 <td>{item.quantity}</td>
 <td>{item.unit}</td>
 <td>
 <button
 type="button"
 className="btn btn-danger btn-sm"
 onClick={() => removeBOQItem(i)}
 >
 <i className="fas fa-trash"></i>
 </button>
 </td>
 </tr>
 ))}
 </tbody>
 </table>
 ) : (
 <p className="text-center text-muted mb-0">
 No BOQ items added yet
 </p>
 )}
 </Card.Body>
 </Card>
 </div>

 {/* ============================ */}
 {/* CHECKLIST SECTION */}
 {/* ============================ */}
 <div className="mb-4">
 <label className="form-label fw-bold">Checklist</label>

 <Card className="border">
 <Card.Body>
 <Row className="g-2 mb-3">
 <Col md={4}>
 <input
 type="text"
 name="item"
 className="form-control"
 placeholder="Checklist item"
 value={checklistItem.item}
 onChange={handleChecklistChange}
 />
 </Col>

 <Col md={3}>
 <select
 name="status"
 className="form-select"
 value={checklistItem.status}
 onChange={handleChecklistChange}
 >
 <option value="Pending">Pending</option>
 <option value="Completed">Completed</option>
 <option value="N/A">N/A</option>
 </select>
 </Col>

 <Col md={3}>
 <input
 type="text"
 name="remarks"
 className="form-control"
 placeholder="Remarks"
 value={checklistItem.remarks}
 onChange={handleChecklistChange}
 />
 </Col>

 <Col md={2}>
 <button
 type="button"
 className="btn btn-primary w-100"
 onClick={addChecklistItem}
 >
 <i className="fas fa-plus me-1"></i> Add
 </button>
 </Col>
 </Row>

 {form.checklist.length > 0 ? (
 <table className="table table-bordered table-sm">
 <thead className="table-light">
 <tr>
 <th>Item</th>
 <th>Status</th>
 <th>Remarks</th>
 <th>Action</th>
 </tr>
 </thead>

 <tbody>
 {form.checklist.map((item, i) => (
 <tr key={i}>
 <td>{item.item}</td>
 <td>
 <span
 className={`badge ${
 item.status === "Completed"
 ? "bg-success"
 : item.status === "Pending"
 ? "bg-warning text-dark"
 : "bg-secondary"
 }`}
 >
 {item.status}
 </span>
 </td>
 <td>{item.remarks || "-"}</td>
 <td>
 <button
 type="button"
 className="btn btn-danger btn-sm"
 onClick={() => removeChecklistItem(i)}
 >
 <i className="fas fa-trash"></i>
 </button>
 </td>
 </tr>
 ))}
 </tbody>
 </table>
 ) : (
 <p className="text-center text-muted mb-0">
 No checklist items added yet
 </p>
 )}
 </Card.Body>
 </Card>
 </div>

 {/* FILE UPLOADS */}
 <div className="mb-3">
 <label className="form-label fw-bold">
 Attach Handover Documents
 </label>

 <input
 type="file"
 className="form-control"
 multiple
 accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.xlsx,.xls"
 onChange={(e) => handleFile(e, "handoverDocuments")}
 />

 {form.handoverDocuments.length > 0 && (
 <div className="mt-3 d-flex flex-wrap gap-2">
 {form.handoverDocuments.map((doc, i) => (
 <FilePreview
 key={i}
 file={doc}
 onRemove={() => removeHandoverDoc(i)}
 />
 ))}
 </div>
 )}
 </div>

 {/* CLIENT SIGNATURE */}
 <div className="mb-4">
 <label className="form-label fw-bold">Client Signature</label>

 <input
 type="file"
 accept="image/*"
 className="form-control"
 onChange={(e) => handleFile(e, "clientSignature")}
 />

 {clientSignPreview && (
 <div className="mt-3">
 <FilePreview
 file={form.clientSignature}
 onRemove={removeClientSign}
 />
 </div>
 )}
 </div>

 {/* ============================ */}
 {/* SUBMIT BUTTONS */}
 {/* ============================ */}

 <div className="mt-4 d-flex gap-2">
 <button
 type="submit"
 className="btn btn-primary"
 disabled={loading}
 >
 {loading ? (
 <>
 <span className="spinner-border spinner-border-sm me-2"></span>
 Saving...
 </>
 ) : (
 <>
 <i className="fas fa-save me-2"></i>
 Save Handover
 </>
 )}
 </button>

 <button
 type="button"
 className="btn btn-danger"
 onClick={() =>
 navigate(
 workOrderFromUrl
 ? `/handover?${projectFromUrl ? `project=${projectFromUrl}&` : ""}workOrder=${workOrderFromUrl}`
 : "/handover"
 )
}
 disabled={loading}
 >
 <i className="fas fa-times me-2"></i>
 Cancel
 </button>
 </div>
 </form>
 </Card.Body>
 </Card>
 </Col>
 </Row>
 </Fragment>
 );
};

export default HandoverAdd;
